import React, { useState } from 'react';

export const TipBtn = ({ icon: Icon, tooltip, active, disabled, onClick, testId, teal = '#47b8a3', size = 42, tipPos = 'above', spinning, pulsing }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <div style={{ position: 'relative', display: 'inline-flex' }}
      onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      <button type="button" data-testid={testId} onClick={onClick} disabled={disabled}
        style={{
          width: size, height: size, borderRadius: 10, border: 'none',
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          cursor: disabled ? 'not-allowed' : 'pointer',
          background: active ? teal : disabled ? '#E5E7EB' : '#F3F4F6',
          color: active ? '#fff' : disabled ? '#9CA3AF' : '#374151',
          transition: 'all 0.18s cubic-bezier(.22,1,.36,1)',
          boxShadow: active ? `0 0 0 3px ${teal}25` : 'none',
          animation: pulsing ? 'pulse-mic 1.2s infinite' : 'none',
        }}>
        <Icon size={18} strokeWidth={2} style={spinning ? { animation: 'spin 1s linear infinite' } : undefined} />
      </button>
      {hovered && !disabled && tooltip && (
        <div style={{
          position: 'absolute', left: '50%', transform: 'translateX(-50%)',
          ...(tipPos === 'above'
            ? { bottom: size + 8, animation: 'tipFadeDown 0.15s ease' }
            : { top: size + 8, animation: 'tipFadeUp 0.15s ease' }),
          background: '#1F2937', color: '#fff', fontSize: 11, fontWeight: 600,
          padding: '4px 10px', borderRadius: 6, whiteSpace: 'nowrap', pointerEvents: 'none',
          zIndex: 50,
        }}>
          {tooltip}
          <div style={{
            position: 'absolute', left: '50%', transform: 'translateX(-50%)',
            ...(tipPos === 'above'
              ? { bottom: -4, borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderTop: '5px solid #1F2937' }
              : { top: -4, borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderBottom: '5px solid #1F2937' }),
            width: 0, height: 0,
          }} />
        </div>
      )}
    </div>
  );
};

export default TipBtn;
